import { GetUserByAuth0Id as GetUserByAuth0IdType } from '@generated/types';
import { GET_LOGGEDIN } from '@services/client-quieries/clienttypes';

import { client, getData } from '..';
import { GetUserByAuth0IdQuery } from '../_services/user/queries';

import { history } from './history';

export async function getUserByAuth0Id(auth0Id: string, role: string, redirectPath?: string) {
  client
    .query<GetUserByAuth0IdType>({
      query: GetUserByAuth0IdQuery,
      variables: { auth0_id: auth0Id, role: role },
    })
    .then((response) => {
      if (response.data && response.data.user && response.data.user.result && response.data.user.result.id) {
        if (response.data.user.result.is_active) {
          client.writeQuery({ query: GET_LOGGEDIN, data: getData() });
          // history.push('/')
          if (redirectPath) {
            history.push(redirectPath, { redirect: true });
          } else {
            window.location.href = process.env.API_URL ? process.env.API_URL : '';
          }
        } else {
          history.push({
            pathname: '/login',
            state: {
              message: 'Your account is deactivated. Kindly contact Administrator',
            },
          });
        }
      }
    });
}
